<button class="open-details global-transition" (click)="openDetails($event)">{{ 'details' | t }}</button>
